import React, { useContext, useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';

import AuthContext from 'common/auth';
import UiContext from 'common/UiContext/UiContext';

import LoginCard from 'components/LoginCard';
import InputPassword from 'components/InputPassword';
import InputEmail from 'components/InputEmail';

const Login = () => {
  const {
    login,
    isLoggingIn,
    loginError,
    loginErrorDetail,
    loginSuccessfull,
    otpRequired,
    otpSuccessful,
    verificationRequired,
  } = useContext(AuthContext)!;
  const { addToast, openModal } = useContext(UiContext);
  const navigate = useNavigate();
  const formMethods = useForm({ mode: 'onChange' });

  const { handleSubmit, formState: { isSubmitting, isDirty, isValid } } = formMethods;

  const onSubmit = ({ password, username }: Record<string, string>) => {
    login(username, password);
  };

  useEffect(() => {
    if(loginError && loginErrorDetail) {
      Object.entries(loginErrorDetail).forEach(([, error]) => {
          addToast!(error, 'Error');
      });
    }
  }, [loginError, loginErrorDetail]);

  useEffect(() => {
    if(loginSuccessfull) {
      if (otpRequired && !otpSuccessful) {
        openModal!('OtpLogin');
      } else if (verificationRequired) {
        navigate('/verification-required');
      }
    }
  }, [loginSuccessfull, otpRequired, otpSuccessful, verificationRequired]);

  return (
    <LoginCard title='Log In' back={false}>
      <FormProvider {...formMethods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <InputEmail field='username' name='Email Address' />
          <InputPassword name='password' />
          <Link className='forgot' to='/reset-password'>Forgot your password?</Link>
          <button
            className='primary big'
            disabled={isLoggingIn || isSubmitting || (!isValid && isDirty)}
          >
            Login
          </button>
          <hr />
        </form>
      </FormProvider>
    </LoginCard>
  );
};

export default Login;